<template>
  <div
    id="supportModal"
    class="modal fade support-modal"
    tabindex="-1"
    aria-labelledby="supportModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Обращение в поддержку</h5>
          <button ref="closeButton" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <textarea
            v-model="support_text"
            class="form-control"
            rows="5"
            placeholder="Подробно опишите свою ситуацию, мы постараемся помочь, как можно скорее."
          ></textarea>
        </div>
        <div class="modal-footer">
          <button type="button" class="black-button" @click="sendMessage">Отправить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, ref } from 'vue';
  import SupportService from '@/services/support';

  export default defineComponent({
    emits: ['close'],
    setup(props, { emit }) {
      const support_text = ref(null);
      const closeButton = ref(null);
      const closeModal = async () => {
        closeButton.value.click();
      };
      const sendMessage = async () => {
        await SupportService.createSupport(support_text.value);
        closeModal();
        alert('Обращение в поддержку отправлено');
      };
      return {
        closeButton,
        support_text,
        closeModal,
        sendMessage,
      };
    },
  });
</script>

<style scoped>
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;

    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    background-color: rgb(0 0 0 / 50%);
  }

  .modal-content {
    width: 400px;
    padding: 20px;

    background-color: white;
    border-radius: 8px;
  }

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .btn-close {
    font-size: 1.5rem;
    line-height: 1;

    background: transparent;
    border: none;
    cursor: pointer;
  }

  textarea.form-control {
    width: 100%;
    margin-bottom: 20px;
  }
</style>
